import { render, staticRenderFns } from "./AgendaEditComponent.vue?vue&type=template&id=6bd75adc"
import script from "./AgendaEditComponent.vue?vue&type=script&lang=js"
export * from "./AgendaEditComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports